import { ChangeEvent, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Stack, TextField } from '@mui/material';

interface DateQueryFormProps {
  from?: string;
  onChangeFrom?: (value: string) => void;
  to?: string;
  onChangeTo?: (value: string) => void;
}

const DateQueryForm = (props: DateQueryFormProps) => {
  const { from, onChangeFrom, to, onChangeTo } = props;
  const handleChangeFrom = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeFrom?.(e.target.value);
    },
    [onChangeFrom]
  );
  const handleChangeTo = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeTo?.(e.target.value);
    },
    [onChangeTo]
  );
  return (
    <Stack width={317} gap={2}>
      <TextField
        size="small"
        type="date"
        fullWidth
        value={from}
        inputProps={{
          max: '9999-12-31',
        }}
        onChange={handleChangeFrom}
        label={<FormattedMessage defaultMessage="From" />}
        // Prevents the label from rendering beneath the native browser date input's value
        // placeholder See: https://github.com/mui/material-ui/issues/8131#issuecomment-328373902
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        size="small"
        type="date"
        fullWidth
        value={to}
        inputProps={{
          max: '9999-12-31',
        }}
        onChange={handleChangeTo}
        label={<FormattedMessage defaultMessage="To" />}
        InputLabelProps={{ shrink: true }}
      />
    </Stack>
  );
};

export { DateQueryFormProps };
export default DateQueryForm;
